export default "__VITE_ASSET__BUKriW6a__"